import React from 'react';
import { Music, ExternalLink, X } from 'lucide-react';

const AudioViewer = ({ 
  isOpen, 
  onClose, 
  resource, 
  title 
}) => {
  if (!isOpen || !resource) return null;

  const { resource_url, resource_name } = resource;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white max-w-2xl w-full rounded-lg overflow-hidden relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-gray-500 hover:text-gray-700"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b pr-16">
          <h3 className="text-xl font-semibold text-gray-900">{title || resource_name}</h3>
        </div>
        
        <div className="p-4">
          {resource_url?.match(/\.(mp3|wav|ogg|m4a|aac|flac)$/i) ? (
            <div className="space-y-4">
              <div className="text-center py-4">
                <Music className="w-16 h-16 text-green-400 mx-auto mb-4" />
                <p className="text-lg font-semibold text-gray-900 mb-2">{resource_name}</p>
              </div>
              <audio controls className="w-full">
                <source src={resource_url} />
                Your browser does not support the audio element.
              </audio>
            </div>
          ) : (
            <div className="text-center py-8">
              <Music className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-600 mb-4">Audio player not available for this URL format</p>
              <a
                href={resource_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                Open External Link
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AudioViewer;